import { render, staticRenderFns } from "./ItemsNotFound.vue?vue&type=template&id=37325cfe&"
import script from "./ItemsNotFound.vue?vue&type=script&lang=js&"
export * from "./ItemsNotFound.vue?vue&type=script&lang=js&"
import style0 from "./ItemsNotFound.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports